export const DATE_FORMAT = 'YYYY-MM-DD' // 2018-02-01
export const DATE_TIME_FORMAT = 'YYYY-MM-DD [/] HH:mm' // 2018-12-11 / 21:30
export const TIME_FORMAT = 'HH:mm'
